import React from 'react';
import CrudTable from '@/components/admin/CrudTable';
import { Layers, Palette, Box, Shapes, Maximize2, Circle, Type, CheckCircle, Package } from 'lucide-react';

const GenericCatalogManager = ({ table }) => {
    // Configuraciones específicas para cada tabla
    const configs = {
        producto: {
            title: 'Base de Productos',
            icon: Package,
            columns: [
                { key: 'producto', label: 'Nombre del Producto', required: true },
                {
                    key: 'categoria_id',
                    label: 'Categoría',
                    type: 'select',
                    optionsTable: 'categoria',
                    displayKey: 'categoria',
                    required: true
                },
                { key: 'estado', label: 'Estado', type: 'boolean' }
            ]
        },
        categoria: {
            title: 'Categorías',
            icon: Layers,
            columns: [
                { key: 'categoria', label: 'Nombre Categoría', required: true },
                { key: 'estado', label: 'Estado', type: 'boolean' }
            ]
        },
        color: {
            title: 'Colores',
            icon: Palette,
            columns: [
                { key: 'color', label: 'Nombre Color', required: true },
                { key: 'hexadecimal', label: 'Hexadecimal', type: 'color' }
            ]
        },
        material: {
            title: 'Materiales',
            icon: Box,
            columns: [
                { key: 'material', label: 'Nombre Material', required: true }
            ]
        },
        textura: {
            title: 'Texturas',
            icon: Shapes,
            columns: [
                { key: 'textura', label: 'Nombre Textura', required: true }
            ]
        },
        presentacion: {
            title: 'Presentaciones',
            icon: Maximize2,
            columns: [
                { key: 'presentacion', label: 'Descripción Presentación', required: true }
            ]
        },
        diametro: {
            title: 'Diámetros',
            icon: Circle,
            columns: [
                { key: 'diametro', label: 'Medida Diámetro', required: true }
            ]
        },
        disenada_para: {
            title: 'Diseñada Para',
            icon: Type,
            columns: [
                { key: 'disenada_para', label: 'Uso / Aplicación', required: true }
            ]
        },
        base: {
            title: 'Bases',
            icon: Layers, // Icono genérico 
            columns: [
                { key: 'base', label: 'Tipo de Base', required: true }
            ]
        }
    };

    const currentConfig = configs[table] || {
        title: table,
        columns: [{ key: 'nombre', label: 'Nombre' }]
    };

    return (
        <CrudTable
            tableName={table}
            title={currentConfig.title}
            icon={currentConfig.icon}
            columns={[
                { key: 'id', label: 'ID', hidden: true }, // Siempre pedimos ID pero lo ocultamos
                ...currentConfig.columns
            ]}
        />
    );
};

export default GenericCatalogManager;
